import React, { useEffect, useState } from 'react'
import Title from '../../../components/ui/Title'
import { InputPrice } from '../../../components/ui/Input'
import Layout from '../../../components/layoutDashBoard/LayoutDashBoard'
import { useBenefit } from '../../../context/BenefitSelectedContext'
import { generateProposalNumber } from '../../../util/functions'
import BankDetails from '../loan/BankDetails'
import { useClient } from '../../../context/ClientContext'
import { useRedux } from '../../../redux/hook/useRedux'
import { actionTypeBenefitUser } from '../../../redux/user/actions'
import SearchableSelect from '../../../components/ui/SearchableSelect'
import BeneficiaryForm from './BeneficiaryForm'
import { actionSendProposalCardBenefit, actionSendProposalCardBmg, actionSendProposalCardMaster } from '../../../redux/card/actions'
import { Alert } from '../../../util/Alert'
import { creditFormEnum, isValidCPF, typeCardEnum } from '../../../model/enum'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/ui/Button'
import { FaBoxes, FaSave } from 'react-icons/fa'
import { useProduct } from '../../../context/ProductSelectedContext';
import { useService } from '../../../context/ServiceSelectedContext';
import { Select } from '../../../components/ui/Select'
import { maskValue } from '../../../util/mask'
import AddressDetails from '../loan/AddressDetails'
import { useGenericFormValidator } from '../../../util/genericFormValidator'
import { actionZipCodeSearch } from "../../../redux/address/actions";
import { useUserData } from '../../../context/UserDataContext'
import { PutClientApi } from '../../../service/controller/ClientsController'
const BenefitCard = ({
    typeCard, title
}) => {
    const { serviceSelected } = useService();
    const [currentStep, setCurrentStep] = useState(1);
    const [income, setIncome] = useState('');
    const { dispatch } = useRedux();
    const { benefitSelected } = useBenefit();
    const { client, setClient } = useClient();
    const [typeBenefits, setTypeBenefits] = useState([]);
    const [selectedTypeBenefit, setSelectedTypeBenefit] = useState(0);
    const [insuranceBeneficiaries, setInsuranceBeneficiaries] = useState([]);
    const navigate = useNavigate();
    const { userData } = useUserData();

    useEffect(() => {
        dispatch(actionTypeBenefitUser(types => {
            setTypeBenefits(types);
        }))
    }, [])

    //Form Endereço
    const [needAddress, setNeedAddress] = useState(false);
    const initialAddressForm = {
        cpf: client?.cpf,
        email: client?.email,
        fullName: client?.nomeCompleto,
        phone: client?.telefone,
        address: client?.endereco?.logradouro,
        cep: client?.endereco?.cep,
        city: client?.endereco?.cidade,
        complement: client?.endereco?.complemento,
        neighborhood: client?.endereco?.bairro,
        number: client?.endereco?.numero,
        uf: client?.endereco?.uf,
    }
    const validationRules = {
        address: {
            required: true
        },
        cep: {
            required: true
        },
        city: {
            required: true
        },
        uf: {
            required: true
        },
        complement: {
            required: false
        },
        neighborhood: {
            required: true
        },
        number: {
            required: true
        },
    }
    const { form: address, errors: addressErrors, handleChange, validate: validateAddressForm, setForm } = useGenericFormValidator(initialAddressForm, validationRules);
    const handleChangeCep = (e) => {
        const { value } = e.target;
        if (value.replaceAll('-', '').length == 8) {
            dispatch(actionZipCodeSearch(value, (response) => {
                const {
                    cep,
                    logradouro,
                    bairro,
                    localidade,
                    uf,
                } = response;
                setForm(prev => ({
                    ...prev,
                    cep: cep,
                    address: logradouro,
                    neighborhood: bairro,
                    city: localidade,
                    uf: uf
                }));
            }))
        } else {
            setForm(prev => ({
                ...prev,
                cep: value,
            }));
        }
        validateAddressForm({ cep: address.cep })
    }
    const addressInputs = [
        { label: 'CEP', name: 'cep', onChange: handleChangeCep, value: address.cep, placeholder: "xxxx-xxx", type: 'text' },
        { label: 'Endereço', name: 'address', onChange: handleChange, value: address.address, placeholder: "Rua xxxxx", type: 'text' },
        { label: 'Número', name: 'number', onChange: handleChange, value: address.number, placeholder: "0000", type: 'text' },
        { label: 'Complemento', name: 'complement', onChange: handleChange, value: address.complement, placeholder: "apartamento xx", type: 'text' },
        { label: 'Cidade', name: 'city', onChange: handleChange, value: address.city, placeholder: "XXXXX", type: 'text' },
        { label: 'Uf', name: 'uf', onChange: handleChange, value: address.uf, placeholder: "XX", type: 'text' },
        { label: 'Bairro', name: 'neighborhood', onChange: handleChange, value: address.neighborhood, placeholder: "XXXXX", type: 'text' },
    ]

    //Limite cartão
    const [useLimitCard, setUseLimitCard] = useState(false);
    const [limitCard, setLimitCard] = useState(0);
    const [limitWithdrawal, setWithdrawal] = useState(0);
    const [installments, setInstallments] = useState(0);
    const [solicitationValue, setSolicitationValue] = useState(0);

    //Seguro
    const [isInsurance, setIsInsurance] = useState(false);

    const [typeShippingFormInvoice, setTypeShippingFormInvoice] = useState('')

    //FORM BANK DETAILS
    const [creditForm, setCreditForm] = useState('');
    const [errosForm, setErrosForm] = useState({});
    const [typeAccount, setTypeAccount] = useState('');
    const [ufAccount, setUfAccount] = useState(client?.identidade?.ufContaBeneficio);
    const [bankDetails, setBankDetails] = useState({
        bankNumber: client?.identidade?.bancoNumero,
        numberAgency: client?.identidade?.agenciaNumero,
        agencyDigit: client?.identidade?.agenciaDV,
        accountNumber: client?.identidade?.contaNumero,
        accountDigit: client?.identidade?.contaDV,
    });

    const validateForm = () => {
        if (!typeShippingFormInvoice) {
            Alert('Selecione uma forma de receber a fatura', '', false, true, false);
            return;
        }

        if (!installments) {
            Alert('Selecione o número de parcelas', '', false, true, false);
            return;
        }

        if (useLimitCard && limitCard <= 0) {
            Alert('Limite do cartão não informado', '', false, true, false);
            return;
        }

        if (!benefitSelected) {
            Alert('Matrícula não informada', '', false, true, false);
            return;
        }

        if (currentStep === 1) {
            if (!income || income <= 0) {
                Alert('Renda inválida', '', false, true, false);
                return false;
            }

            if (!selectedTypeBenefit) {
                Alert('Tipo de benefício não selecionado', '', false, true, false);
                return false;
            }

            return true;
        }

        if (currentStep === 2) {

            if (!typeAccount) {
                Alert('Tipo de conta não informado', '', false, true, false);
                return false;
            }

            if (!ufAccount) {
                Alert('UF da conta não informado', '', false, true, false);
                return false;
            }

            if (creditForm == creditFormEnum.bankTransfer.id) {

                if (!bankDetails?.bankNumber) {
                    Alert('Número do banco é obrigatório', '', false, true, false);
                    return false;
                }

                if (!bankDetails?.numberAgency) {
                    Alert('Agência bancária é obrigatória', '', false, true, false);
                    return false;
                }

                if (!bankDetails?.accountNumber) {
                    Alert('Número da conta é obrigatório', '', false, true, false);
                    return false;
                }
            }
            return true;
        }

        return true;
    }

    const getForm = () => {
        const form = {
            "valorRenda": income,
            "tipoBeneficio": selectedTypeBenefit,
            "produto": "0",
            "codigoServico": String(serviceSelected),
            "matricula": String(benefitSelected),
            "numeroParcelas": installments,
            "valorSaque": solicitationValue,
            "formaCredito": 2,
            "banco": { numero: bankDetails.bankNumber },
            "agencia": { numero: bankDetails.numberAgency, digitoVerificador: bankDetails.agencyDigit },
            "conta": { numero: bankDetails.accountNumber, digitoVerificador: bankDetails.accountDigit },
            "beneficiariosSeguro": insuranceBeneficiaries,
            "numeroPropostaExterna": generateProposalNumber(),
            "seguros": [{ tipoSeguro: 1, codigoPlano: 101 }], // por enquanto fixo
            "ufContaBeneficio": ufAccount,
            "tipoDomicilioBancario": typeAccount,
            "tipoFormaEnvioFatura": typeShippingFormInvoice,
            "valorParcela": 0, // valor default
            "codigoEntidade": 1581, //INSS
            "tipoSaque": 2, // valor default
            // "token": "string", // celio vai validar
        }

        return form;
    };

    const onSendProposal = () => {
        if (validateForm()) {
            const form = getForm();
            if (form) {
                const actions = typeCard === typeCardEnum.master
                    ? actionSendProposalCardMaster
                    : typeCard === typeCardEnum.bmg
                        ? actionSendProposalCardBmg
                        : actionSendProposalCardBenefit
                dispatch(actions(form, res => {
                    Alert('Proposta gerada com sucesso');
                    navigate('/dashboard/my-contracts');
                }, () => {
                    Alert('Atenção', 'É necessário atualizar os dados de Endereço.', false, false, true);
                    setNeedAddress(true);
                }))
            }
        }
    }

    useEffect(() => {
        if (useLimitCard && income > 0) {
            // O limite do Cartão é de 5% da renda da pessoa X 32.
            const limit = (income * 0.05) * 32;
            setLimitCard(limit);
            if (limit > 0) {
                //O limite de saque é de 70% desse valor
                const withdrawal = (limit * 0.7);
                setWithdrawal(withdrawal <= 0 ? 0 : withdrawal);
                setSolicitationValue(withdrawal);
            }

        }
    }, [useLimitCard, income])

    const onChangeSolicitationValue = (value) => {
        if (value > limitWithdrawal && useLimitCard) {
            Alert(`Informe um valor até ${maskValue(limitWithdrawal)}`, '', false, false, true);
            setSolicitationValue(limitWithdrawal)
            return;
        }
        setSolicitationValue(value)
    }

    const updateClientData = () => {
        if (validateAddressForm()) {
            var requestPutUser = {
                ...client,
                "endereco": {
                    "cep": address.cep.replace("-", ""),
                    "logradouro": address.address,
                    "numero": address.number,
                    "complemento": address.complement,
                    "bairro": address.neighborhood,
                    "cidade": address.city,
                    "uf": address.uf
                },
            }
            PutClientApi(requestPutUser, userData.id, (data) => {
                setClient(data);
                setNeedAddress(false);
                Alert('Dados Atualizados com sucesso!');
            })
        }
    }

    return (
        <Layout>
            <small className='text-gray-400 flex items-center gap-3'><FaBoxes /> {title}</small>
            {needAddress && <React.Fragment>
                <AddressDetails addressDetails={{
                    address,
                    addressErrors,
                    addressInputs
                }} />
                <div className="flex items-center justify-end">
                    <Button className="flex items-center justify-end" onClick={updateClientData}><FaSave />Salvar</Button>
                </div>
            </React.Fragment>}
            {!needAddress && <React.Fragment>

                <div className="flex items-center justify-center w-full gap-5 mb-5">
                    <div className={`w-[150px] h-2 rounded-lg bg-${currentStep >= 1 ? '[#FA6300]' : 'gray-400'}`}></div>
                    <div className={`w-[150px] h-2 rounded-lg bg-${currentStep >= 2 ? '[#FA6300]' : 'gray-400'}`}></div>
                </div>
                {currentStep === 1 && <React.Fragment>
                    <Title
                        text1={'Dados do'}
                        text2={'Benefício'}
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                        <SearchableSelect
                            label='Tipo De Benefício'
                            options={typeBenefits.map(x => ({ value: x.codigo, label: x.descricao }))}
                            onChange={value => setSelectedTypeBenefit(value)}
                            value={selectedTypeBenefit}
                            className={'w-full'}
                        />
                        <InputPrice
                            label={'Qual é o valor da sua renda?'}
                            prefix={'R$'}
                            value={income}
                            onChangeValue={value => setIncome(value)}
                        />
                        <Select
                            variant='rounded'
                            label='Selecione o número de parcelas'
                            value={installments}
                            onChange={e => setInstallments(e.target.value)}
                        >
                            <option value="12">12x</option>
                            <option value="18">18x</option>
                            <option value="24">24x</option>
                            <option value="36">36x</option>
                            <option value="48">48x</option>
                            <option value="60">60x</option>
                            <option value="72">72x</option>
                            <option value="84">84x</option>
                            <option value="96">96x</option>
                        </Select>
                        <Select
                            variant='rounded'
                            label='Como deseja receber sua fatura?'
                            value={typeShippingFormInvoice}
                            onChange={e => setTypeShippingFormInvoice(e.target.value)}
                        >
                            <option value="D">Fatura enviada por e-mail</option>
                            <option value="W">Fatura enviada por WhatsApp</option>
                        </Select>
                    </div>
                    <Title
                        text1={`Agora você pode usar o LIMITE DO CARTÃO para realizar saques`}
                        text2={'diretamente na sua conta.'}
                    />
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5 w-full">
                        <Select
                            value={useLimitCard ? 'y' : 'n'}
                            onChange={(e) => setUseLimitCard(e.target.value === 'y')}
                            variant='rounded'
                            hiddenDefaultValue
                            label={'Deseja ultilizar o limite do cartão?'}
                        >
                            <option value="n">Não</option>
                            <option value="y">SIM</option>
                        </Select>
                        <div className="">
                            {income > 0 && < InputPrice
                                label={useLimitCard ? `Qual limite para saque deseja utilizar?` : `Qual é o valor que deseja?`}
                                prefix={'R$'}
                                value={solicitationValue}
                                className=' w-full'
                                onChangeValue={value => onChangeSolicitationValue(value)}
                            />}
                            {useLimitCard && limitWithdrawal > 0 && <h1 className='text-end text-gray-400 mb-5'>Você pode ter até {maskValue(limitWithdrawal)} liberado para saque!</h1>}
                        </div>
                    </div>
                    {income > 0 && solicitationValue > 0 && <div className="flex items-center justify-end">
                        <Button onClick={() => { validateForm() && setCurrentStep(2) }}>Próximo</Button>
                    </div>}
                </React.Fragment>}
                {currentStep === 2 && <React.Fragment>
                    <Title
                        text1={'Dados do'}
                        text2={'Seguro'}
                    />
                    <Select
                        divClass={'w-full md:w-[350px] mb-5'}
                        value={isInsurance ? 'y' : 'n'}
                        onChange={(e) => setIsInsurance(e.target.value === 'y')}
                        variant='rounded'
                        hiddenDefaultValue
                        label={'Deseja incluir seguro?'}
                    >
                        <option value="n">Não</option>
                        <option value="y">SIM</option>
                    </Select>
                    {isInsurance && <BeneficiaryForm
                        insuranceBeneficiaries={insuranceBeneficiaries}
                        setInsuranceBeneficiaries={setInsuranceBeneficiaries}
                    />}
                    <div className='m-5' />
                    <BankDetails
                        bankDetailsForm={{
                            creditForm,
                            setCreditForm,
                            typeAccount,
                            setTypeAccount,
                            ufAccount,
                            setUfAccount,
                            bankDetails,
                            setBankDetails,
                            errosForm,
                            onSendProposal,
                        }}
                        onBack={() => setCurrentStep(1)}
                    />
                </React.Fragment>}
            </React.Fragment>}
        </Layout>
    )
}

export default BenefitCard